import axios from "axios";
import { api_path } from "../environment";
import { setHeaders } from "./baseApi";

// s'authentifier
export const login = async (data) => {
  const response = await axios({
    method: "post",
    url: `${api_path}/api/auth/login`,
    data: data,
    headers: setHeaders(),
    withCredentials: setHeaders().withCredentials,
  });
  return response;
};

// verifier l'etat d'authentification
export const checkAuth = async () => {
  const res = await axios.get(api_path + `/api/auth/getMe`, {
    headers: setHeaders(),
    withCredentials: setHeaders().withCredentials,
  });
  return res.data;
};

// la deconnexion
export const logout = async () => {
  const res = await axios.post(
    api_path + `/api/auth/logout`,
    {},
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return res.data;
};
